import { COPY_TOGGLE_KEYS } from "./constants";

/**
 * Build plain-text copy output from script and preferences.
 * Suitable for pasting into docs, Notion, email, chat, or AI tools.
 */
export function serializeScriptForCopy(script, preferences, currentUrl = "") {
  const parts = [];
  const title = script?.idea_title || "Script";
  const description = script?.script_data?.description ?? script?.idea?.content ?? script?.description ?? "";
  const direction = script?.context?.user_prompt ?? "";
  const masterCaption = script?.script_data?.master_caption ?? "";
  const scenes = Array.isArray(script?.script_data?.scenes) ? script.script_data.scenes : [];

  if (preferences[COPY_TOGGLE_KEYS.title]) {
    parts.push(title);
    parts.push("");
  }

  if (preferences[COPY_TOGGLE_KEYS.description] && description) {
    parts.push("Description:");
    parts.push(description);
    parts.push("");
  }

  if (preferences[COPY_TOGGLE_KEYS.direction] && direction) {
    parts.push("Direction:");
    parts.push(direction);
    parts.push("");
  }

  if (preferences[COPY_TOGGLE_KEYS.masterCaption] && masterCaption) {
    parts.push("Master caption:");
    parts.push(masterCaption);
    parts.push("");
  }

  const includeSpoken = preferences[COPY_TOGGLE_KEYS.sceneSpoken];
  const includeCaptions = preferences[COPY_TOGGLE_KEYS.sceneCaptions];
  const includeVisual = preferences[COPY_TOGGLE_KEYS.sceneVisualNotes];
  const includeAnyScene = includeSpoken || includeCaptions || includeVisual;

  if (includeAnyScene && scenes.length > 0) {
    parts.push("---");
    parts.push("");

    scenes.forEach((scene, idx) => {
      const num = scene.scene_number ?? idx + 1;
      const dur = scene.duration_seconds != null ? ` (${Math.round(Number(scene.duration_seconds))}s)` : "";
      parts.push(`Scene ${num}${dur}`);
      if (includeSpoken) {
        const speaker = scene.speaker ? `[${scene.speaker}] ` : "";
        parts.push(`Spoken: ${speaker}${scene.spoken_text || ""}`);
      }
      if (includeCaptions && scene.on_screen_text) {
        parts.push(`Caption: ${scene.on_screen_text}`);
      }
      if (includeVisual) {
        if (scene.visual_description) {
          parts.push(`Visual: ${scene.visual_description}`);
        }
        if (scene.style_notes) {
          parts.push(`Style: ${scene.style_notes}`);
        }
      }
      parts.push("");
    });

    parts.push("---");
    parts.push("");
  }

  if (preferences[COPY_TOGGLE_KEYS.url] && currentUrl) {
    parts.push(currentUrl);
  }

  return parts.join("\n").trim();
}

/**
 * Serialize a single scene for copy (per-scene copy action).
 */
export function serializeSceneForCopy(scene, index) {
  const num = scene.scene_number ?? index + 1;
  const dur = scene.duration_seconds != null ? ` (${Math.round(Number(scene.duration_seconds))}s)` : "";
  const speaker = scene.speaker ? `[${scene.speaker}] ` : "";
  const parts = [`Scene ${num}${dur}`, `Spoken: ${speaker}${scene.spoken_text || ""}`];
  if (scene.on_screen_text) {
    parts.push(`Caption: ${scene.on_screen_text}`);
  }
  if (scene.visual_description) {
    parts.push(`Visual: ${scene.visual_description}`);
  }
  if (scene.style_notes) {
    parts.push(`Style: ${scene.style_notes}`);
  }
  return parts.join("\n");
}
